import { Container, Paper } from "@mui/material"
import { FunctionComponent, useEffect, useState } from "react"
import Dimen from "../Dimen"
import GooglePlay from "../assets/google-play-badge.png"
import AppStore from "../assets/app-store-badge.png"
import { paperStyleDefault } from "../Style"
import { Timestamp } from "firebase/firestore"
import { urlAppStore, urlGooglePlay } from "./HomePage"
import { FormattedMessage, useIntl } from "react-intl"
import { Locale } from "../App"
import { getAnalytics } from "firebase/analytics"
import Pricing from "./Pricing"
import { Caller } from "../Enum"

const lineStyle = {
  paddingTop: "8px",
  paddingBottom: "8px",
}

const dateOptions: Intl.DateTimeFormatOptions = {
  weekday: "long",
  year: "numeric",
  month: "long",
  day: "numeric",
  hour: "2-digit",
  minute: "numeric",
  second: "numeric",
  // dateStyle: "full",
  // timeStyle: "full",
}

const SubscriptionView: FunctionComponent<{
  locale: Locale
  uid: string
  startDate: Timestamp
  endDate: Timestamp
  product: string
  subscriber: boolean
}> = ({
  locale,
  uid,
  startDate: subStartDate,
  endDate: subEndDate,
  product,
  subscriber: isSubscribed,
}) => {
  const intl = useIntl()
  const [subscriber, setSubscriber] = useState(false)
  const [subscription, setSubscription] = useState(
    intl.formatMessage({
      id: "subscription.free",
    })
  )
  const [startDate, setStartDate] = useState("-")
  const [endDate, setEndDate] = useState("-")

  const localeDate = locale === Locale.Bengali ? "bn-BD" : "en-US"

  useEffect(() => {
    setSubscriber(isSubscribed)
    setStartDate(
      subStartDate.toDate().toLocaleDateString(localeDate, dateOptions)
    )
    setEndDate(subEndDate.toDate().toLocaleDateString(localeDate, dateOptions))
    setSubscription(getSubscriptionType(product))
  }, [uid, localeDate])

  const getSubscriptionType = (subscription: string): string => {
    switch (subscription) {
      case "Pro subscription":
        return intl.formatMessage({
          id: "subscription.pro",
        })
      case "Enterprise subscription":
        return intl.formatMessage({
          id: "subscription.enterprise",
        })
      case "Trial subscription":
        return intl.formatMessage({
          id: "subscription.trial",
        })

      default:
        return intl.formatMessage({
          id: "subscription.free",
        })
    }
  }

  const getSubscriptionStatusMsg = (): string => {
    if (subscriber) {
      return intl.formatMessage({
        id: "subscription.status.active",
      })
    } else if (startDate === undefined || startDate === "-") {
      return intl.formatMessage({
        id: "subscription.purchase",
      })
    } else {
      return intl.formatMessage({
        id: "subscription.renew",
      })
    }
  }

  return (
    <Container maxWidth="lg" style={{ paddingTop: "16px" }}>
      <div style={{ fontSize: Dimen.FontSizeSubHeading }}>
        <FormattedMessage id="subscription.subtitle.one" />
      </div>
      <Paper elevation={3} style={paperStyleDefault}>
        <div style={lineStyle}>
          <b>
            {" "}
            <FormattedMessage id="name" />:
          </b>{" "}
          {subscription}
        </div>
        <div style={lineStyle}>
          <b>
            <FormattedMessage id="status" />:
          </b>{" "}
          {getSubscriptionStatusMsg()}
        </div>
        <div style={lineStyle}>
          <b>
            <FormattedMessage id="dateOfPurchase" />:
          </b>{" "}
          {startDate}
        </div>
        <div style={lineStyle}>
          <b>
            <FormattedMessage id="dateOfExpiry" />:
          </b>{" "}
          {endDate}
        </div>
      </Paper>

      {/* Renew method bKash */}
      <div>
        <div
          style={{
            fontSize: Dimen.FontSizeSubHeading,
            marginTop: Dimen.MarginDefault2x,
          }}
        >
          {startDate === "-" ? (
            intl.formatMessage({
              id: "subscription.purchase.method.one",
            })
          ) : (
            <FormattedMessage id="subscription.subtitle.two" />
          )}
        </div>
        <Paper elevation={3} style={paperStyleDefault}>
          <Pricing caller={Caller.Subscription} />
        </Paper>
      </div>

      {/* Renew method Google Pay */}
      <div>
        <div
          style={{
            fontSize: Dimen.FontSizeSubHeading,
            marginTop: Dimen.MarginDefault2x,
          }}
        >
          {startDate === "-" ? (
            intl.formatMessage({
              id: "subscription.purchase.method.two",
            })
          ) : (
            <FormattedMessage id="subscription.subtitle.three" />
          )}
        </div>
        <Paper elevation={3} style={paperStyleDefault}>
          <div style={{ paddingTop: Dimen.MarginDefault }}>
            <FormattedMessage id="subscription.purchase.method.two" />
          </div>
          <a href={urlGooglePlay} target="_blank">
            <img
              alt="এন্ড্রোয়েড ভার্সন"
              src={GooglePlay}
              width="323"
              height="125"
            />
          </a>
          <a href={urlAppStore} target="_blank">
            <img alt="এপেল ভার্সন" src={AppStore} width="323" height="125" />
          </a>
        </Paper>
      </div>
    </Container>
  )
}
export default SubscriptionView
